import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'
import GrunnbokIcon from '../../../../images/Grunnbok.png'

import HjemmelsopplysningList from './HjemmelsopplysningList.jsx'
import PengeheftelseList from './PengeheftelseList.jsx'
import ServituttList from './ServituttList.jsx'
import RettighetList from './RettighetList.jsx'
import GrunndataList from './GrunndataList.jsx'
import OrderBekreftetGrunnbok from './OrderBekreftetGrunnbok.jsx'
import OrderTinglysteDokumenter from './OrderTinglysteDokumenter.jsx'
import SearchTinglystDokument from './SearchTinglystDokument.jsx'
import MatrikkelSearchEvents from '../../MatrikkelSearchEvents.js'

import kommuner from './kommune.json'
import kommuner2020 from './kommune2020.json'
import Grunnbokrapport from './Grunnbokrapport.jsx';

import GammelGrunnbokViewer from './GammelGrunnbokViewer/GammelGrunnbokViewer.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import GrunnbokrapportIcon from '../../../../images/Grunnboksrapport.png'
import HistoriskGrunnbokrapportIcon from '../../../../images/Historisk grunnbok.png'
import GammelgrunnbokIcon from '../../../../images/gammel grunnbok.png'
import SokPantebokIcon from '../../../../images/Søk etter pantebøker.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'
import WarningIcon from '../../../../images/advarsel2.png'

class GrunnbokList extends Component {
    state = {
        isOpened: false,
        isDocumentSearchActive: false,
        isGrunnbokrapportActive: false,
        isOrderBekreftetGrunnbokActive: false,
        isOrderTinglysteDokumenterActive: false
    }

    find2020Kommune = (kommunenummer2024) => {
        if (kommuner2020[kommunenummer2024]) {
            return kommuner2020[kommunenummer2024];
        }

        return kommunenummer2024;

        // for (var kommunenummer2020 in kommuner) {
        //     var kommunenummer1947List = kommuner[kommunenummer2020].split(',')
        //     if (kommunenummer1947List.includes(kommunenummer1947.toString())) {
        //         return kommunenummer2020;                
        //     }
        // }

        // return kommunenummer1947;
    }
    

    toggleGrunnbok = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    documentSearch = () => {
        this.props.onGrunnbokEvent({
            type: MatrikkelSearchEvents.ExpandGrunnbok
        })

        this.setState({isDocumentSearchActive: true})
    }

    grunnbokrapport = () => {
        this.props.onGrunnbokEvent({
            type: MatrikkelSearchEvents.ExpandGrunnbok
        })

        this.setState({isGrunnbokrapportActive: true})
    }

    orderBekreftetGrunnbok = () => {
        this.props.onGrunnbokEvent({
            type: MatrikkelSearchEvents.ExpandGrunnbok
        })

        this.setState({isOrderBekreftetGrunnbokActive: true})
    }

    orderTinglysteDokumenter = () => {
        this.props.onGrunnbokEvent({
            type: MatrikkelSearchEvents.ExpandGrunnbok
        })
        
        this.setState({isOrderTinglysteDokumenterActive: true})
    }

    handleNavigateBack = () => {
        this.setState({isDocumentSearchActive: false, isGrunnbokrapportActive: false, isOrderBekreftetGrunnbokActive: false, isOrderTinglysteDokumenterActive: false})
        this.props.onGrunnbokEvent({
            type: MatrikkelSearchEvents.ExpandGrunnbokEnd
        })
    }

    downloadGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/rapport?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    downloadHistoriskGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/grunnbokhistorikk?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    downloadKartverketGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/kartverket/rapport?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }

    downloadKartverketHistoriskGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/grunnbok/kartverket/grunnbokhistorikk?kommunenummer=${this.props.kommunenummer}&gardsnummer=${this.props.gardsnummer}&bruksnummer=${this.props.bruksnummer}&festenummer=${this.props.festenummer}&seksjonsnummer=${this.props.seksjonsnummer}&token=${this.props.token}`
        window.open(url, '_blank')
    }


    showGammelGrunnbok = (event) => {
        event.stopPropagation()

        //var kommunenummer = this.find2020Kommune(this.props.kommunenummer);
        this.setState({
            gammelGrunnbok: {
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
    }

    searchPanteboker = (event) => {
        event.stopPropagation()
        var kommunenummer = `000${this.props.kommunenummer}`.slice(-4)

        var municipalities = kommunenummer
        if (kommuner[kommunenummer]) {
            var kommunenummer1947 = kommuner[kommunenummer].split(',')
            municipalities = kommunenummer1947.join('&municipalities[]=')
        }

        var url = `https://media.digitalarkivet.no/tl/pbok/browse?municipalities[]=${municipalities}`
        window.open(url, '_blank')
    }

    handleCloseGammelGrunnbok = () => {
        if (this.state.gammelGrunnbok == null) return
        this.setState({gammelGrunnbok: null})
    }

    overlayStyle = {
        top: '50px',
        padding: '25px'
    }

    contentStyle = {
        border: '0',
        height: '100%',
        width: '80%',
        padding: '0'
    }

    render() {
        const { t } = this.props

        if (this.state.isDocumentSearchActive) return (<SearchTinglystDokument kommunenummer={this.props.kommunenummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.handleNavigateBack} />)
        if (this.state.isGrunnbokrapportActive) return (<Grunnbokrapport kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} erFramfeste={this.props.erFramfeste} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.handleNavigateBack} />)
        if (this.state.isOrderBekreftetGrunnbokActive) return (<OrderBekreftetGrunnbok kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.handleNavigateBack} />)
        if (this.state.isOrderTinglysteDokumenterActive) return (<OrderTinglysteDokumenter kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onNavigateBack={this.handleNavigateBack} />)

        return (
            <li>
                <div className="section-header" onClick={this.toggleGrunnbok}>
                    <Popup contentStyle={this.contentStyle} overlayStyle={this.overlayStyle} open={this.state.gammelGrunnbok != null} onClose={this.handleCloseGammelGrunnbok}>
                        <GammelGrunnbokViewer gammelGrunnbok={this.state.gammelGrunnbok} token={this.props.token} settings={this.props.settings} onClose={this.handleCloseGammelGrunnbok} />
                    </Popup>
                    <div className="icon-image"><img src={GrunnbokIcon} /></div>
                    <span className="title grunnbok">{t('grunnbok')}</span>

                    { !this.props.tinglyst &&
                        <div className="icon-image tooltip warning">
                            <img src={WarningIcon} />
                            <div className="tooltip-content">{t('matrikkelenhetikketinglyst')}</div>
                        </div> }
                    
                    { this.props.tinglyst && <React.Fragment>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>

                    <div className="icon-image right tooltip" onClick={this.searchPanteboker}>
                        <img className="tool" src={SokPantebokIcon} />
                        <div className="tooltip-content">{t('soketterpanteboker')}</div>
                    </div>
                    <div className="icon-image right tooltip" onClick={this.showGammelGrunnbok}>
                        <img className="tool" src={GammelgrunnbokIcon} />
                        <div className="tooltip-content">{t('gammelgrunnbok')}</div>
                    </div>
                    <div className="icon-image right tooltip" onClick={this.downloadKartverketHistoriskGrunnbok}>
                        <img className="tool" src={HistoriskGrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('historiskgrunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div>
                    { !this.props.utgatt &&
                    <div className="icon-image right tooltip" onClick={this.downloadKartverketGrunnbok}>
                        <img className="tool" src={GrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('grunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste  && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div> }
                    {/* <div className="icon-image right tooltip" onClick={this.downloadHistoriskGrunnbok}>
                        <img className="tool" src={HistoriskGrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('historiskgrunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div>
                    { !this.props.utgatt &&
                    <div className="icon-image right tooltip" onClick={this.downloadGrunnbok}>
                        <img className="tool" src={GrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('grunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste  && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div> } */}
                    </React.Fragment> }
                </div>
                { this.props.tinglyst && <div className={this.state.isOpened ? '' : ' collapsed'}>
                    <ul>
                        { !this.props.utgatt &&
                        <li>
                            <div className="section-header subsection" onClick={this.grunnbokrapport}>
                                <div className="icon-image"><img src={PilIcon} /></div>
                                <span className="title">{t('spesifisertgrunnboksrapport')}</span>
                            </div>
                        </li> }
                        <li>
                            <div className="section-header subsection" onClick={this.documentSearch}>
                                <div className="icon-image"><img src={PilIcon} /></div>
                                <span className="title">{t('sokettertinglystdokument')}</span>
                            </div>
                        </li>
                        { !this.props.utgatt && <React.Fragment>
                        { this.props.settings.hasGrunnbokBestilling && <li>
                            <div className="section-header subsection" onClick={this.orderBekreftetGrunnbok}>
                                <div className="icon-image"><img src={PilIcon} /></div>
                                <span className="title">{t('bestillbekreftetgrunnbok')}</span>
                            </div>
                        </li> }
                        { this.props.settings.hasGrunnbokBestilling && <li>
                            <div className="section-header subsection" onClick={this.orderTinglysteDokumenter}>
                                <div className="icon-image"><img src={PilIcon} /></div>
                                <span className="title">{t('bestilltinglystedokumenter')}</span>
                            </div>
                        </li> }
                        </React.Fragment> }
                    </ul>
                    { !this.props.utgatt &&
                    <ul>
                        <HjemmelsopplysningList kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                        <PengeheftelseList kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                        <ServituttList kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                        <RettighetList kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                        <GrunndataList kommunenummer={this.props.kommunenummer} gardsnummer={this.props.gardsnummer} bruksnummer={this.props.bruksnummer} festenummer={this.props.festenummer} seksjonsnummer={this.props.seksjonsnummer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} />
                    </ul> }
                </div> }
            </li>
        )
    }
}

export default withTranslation('common')(GrunnbokList)